<template>
  <!-- Testimonials 2 -->
  <div
    class="section section-testimonials-2 pt-0"
    v-waypoint="{
      active: isActive,
      callback: onWaypoint,
      options: intersectionOptions,
    }"
  >
    <div class="md-layout md-layout-item">
      <div class="md-layout-item">
        <div class="md-layout-item md-size-100" v-touch:swipe="swipeHandler">
          <el-carousel
            ref="photoFrame"
            :type="typeCard"
            trigger="click"
            :arrow="showArrow"
            :interval="5000"
          >
            <el-carousel-item
              v-for="testimonial in testimonialsPublished"
              :key="testimonial.testimonialId"
            >
              <testimonial-card>
                <template #cardContent>
                  <h5 class="card-description black">
                    {{ testimonial.text }}
                  </h5>
                  <h4 class="card-title">{{ testimonial.personName }}</h4>
                  <h6 class="card-category text-muted">
                    {{ testimonial.personPosition }},
                    {{ testimonial.personCompany }}
                  </h6>
                </template>
              </testimonial-card>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  <!-- end Testimonials 2 -->
</template>

<script>
import { TestimonialCard } from "@/components";

export default {
  name: "TestimonialsSection",
  components: {
    TestimonialCard,
  },
  props: {
    testimonials: Array,
    default: [],
  },
  data() {
    return {
      isActive: true,
      showArrow: "never",
      typeCard: "card",
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
      },
      //testimonials: []
    };
  },
  computed: {
    testimonialsPublished() {
      return this.testimonials && this.testimonials.length > 0
        ? this.testimonials.filter((i) => i.published === "Y")
        : null;
    },
  },
  methods: {
    onResize() {
      this.typeCard = window.innerWidth >= 650 ? "card" : "";
    },
    swipeHandler(direction) {
      if (direction == "left") {
        this.$refs.photoFrame.next();
      }

      if (direction == "right") {
        this.$refs.photoFrame.prev();
      }
    },
    onWaypoint({ going, direction }) {
      if (window.innerWidth >= 650) {
        this.showArrow = "hover";
        this.isActive = false;
        window.removeEventListener("scroll", this.handleScroll);
      } else {
        // going: in, out
        // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
          this.showArrow = "always";
          this.isActive = false;
          setTimeout(() => {
            this.showArrow = "never";
          }, 3000);
        }
      }
    },
    handleScroll(event) {
      // Any code to be executed when the window is scrolled
      this.isActive = true;
      this.showArrow = "always";
    },
  },
  mounted() {
    this.onResize();
  },
  created() {
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped></style>
